import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as usersettingsActions from '../actions/user-settings';
import { UserSettingsHttpService } from '../services/user-settings-http.service';
import { UserSettings } from '../models/user-settings';

@Injectable()
export class UserSettingsEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly userSettingsService: UserSettingsHttpService
  ) { }

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(usersettingsActions.LOAD, usersettingsActions.LOAD_FROM_SIGNIN),
    switchMap(() => {
      return this.userSettingsService.getUserSettings().pipe(
        map((labels: UserSettings) => new usersettingsActions.LoadComplete(labels)),
        catchError(err => of(new usersettingsActions.LoadError(err)))
      );
    })));
}
